import React, { useEffect } from 'react'
import { useRoute } from '@react-navigation/native'
import { useDispatch } from 'react-redux'
import { AppRouteProp } from '@navigation/types'
import { MealEditorWrapper } from '@screens/Meals'
import { getDraftMeal } from '@screens/Meals/utils'

export const CreateMeal = () => {
  const dispatch = useDispatch()
  const { params = {} } = useRoute<AppRouteProp<'AddMeal'>>()
  const { mealKind } = params

  // Handle creating a new meal by clicking on notification
  useEffect(() => {
    if (!mealKind) {
      return
    }

    dispatch({
      type: 'meals/saveDraft',
      payload: getDraftMeal({ title: mealKind.toUpperCase(), kind: mealKind }),
    })
  }, [dispatch, mealKind])

  return <MealEditorWrapper />
}
